module.exports = "/_next/static/images/platform_2-76cb9885efd068502a29fab1be669daf.png";